import request from '@/config/axios'

// 房态变更记录 VO
export interface RoomStateVO {
  id: string | number
  shopId: string | number
  roomId: string | number
  oldState: number
  newState: number
  changeType: string
  operatorName: string
  remark: string
  createTime: Date
}

// 获取房态分页
export function getRoomStatePage(params: any) {
  return request.get({ url: '/hotel/room-state/page', params })
}
